import { render, staticRenderFns } from "./FreePage.vue?vue&type=template&id=53721659&scoped=true"
import script from "./FreePage.vue?vue&type=script&lang=js"
export * from "./FreePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53721659",
  null
  
)

export default component.exports